import { HardwareRequestStatus } from "src/api/types.generated";

/**
 * Formats a HardwareRequestStatus enum value (e.g. "PICKED_UP") into a
 * human-readable Title Case string (e.g. "Picked up") for display.
 */
export const formatHardwareRequestStatus = (
  status: HardwareRequestStatus | string
): string => status.charAt(0) + status.slice(1).toLowerCase().replace("_", " ");
